import { render } from "./Dashboard.vue?vue&type=template&id=356e8cba&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=356e8cba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-356e8cba"

export default script